<template>
	<div
		class="flex justify-between equipmentFailure">
		<div class="realTimeAlarm">
			<el-progress :color="'#43FFB9'" :width="progressWidth" type="circle" :stroke-width="strokeWidth" :percentage="alarmRateInfo.AlarmRate"></el-progress>
			
			<div class="flex flex-direction text-white justify-center">
				<div class="text-xsss">
					设备故障率： <br>
					<span class="text-xl text-bold">{{ alarmRateInfo.AlarmRate }}</span>
				</div>
				<!-- <div class="text-12">
					对比上个月：
					<span class="text-xs text-bold">{{ alarmRateInfo.alarmRateAdd }}</span>
				</div> -->
			</div>
		</div>
		<div class="realTimeAlarm flex">
			<el-progress :color="'#129BFF'" :width="progressWidth" type="circle" :stroke-width="strokeWidth" :percentage="alarmRateInfo.StopStationLong"></el-progress>

			<div class="flex flex-direction text-white justify-center">
				<div class="text-xsss">
					设备停站时长：<br>
					<span class="text-xl text-bold">{{ alarmRateInfo.StopStationLong }}</span>
				</div>
				<!-- <div class="text-12">
					对比上个月：
					<span class="text-xs text-bold">{{ alarmRateInfo.stopStationLongAdd }}</span>
				</div> -->
			</div>
		</div>
		<div class="realTimeAlarm flex">
			<el-progress :color="'#31FBFB'" :width="progressWidth" type="circle" :stroke-width="strokeWidth" :percentage="alarmRateInfo.StopStationRate"></el-progress>

			<div class="flex flex-direction text-white justify-center">
				<div class="text-xsss">
					设备停站故障率：<br>
					<span class="text-xl text-bold">{{ alarmRateInfo.StopStationRate}}</span>
				</div>
				<!-- <div class="text-12">
					对比上个月：
					<span class="text-xs text-bold">{{ alarmRateInfo.stopStationRateAdd }}</span>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import Echart from '@/common/echart';
// import {
// 	getSizeByScreen
// } from '@/utils/index';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
	data() {
		return {
			progressWidth: 60,
			strokeWidth: 10,
			alarmRateInfo: {
				alarmRate: 0,
				alarmRateAdd: 0,
				stopStationLong: 0,
				stopStationLongAdd: 0,
				stopStationRateAdd: 0,
			}
		};
	},
	components: {
		Echart,
	},
    inject: ['cityUpdate'],
    computed: {
        computedProperty() {
        	return this.cityUpdate()
        }
    },
    watch: {
        computedProperty(val) {
			this.getData(val)
        },
    },
	mounted() {},
	methods: {
		getData(data) {
			this.selectAlarmRateInfo(data);
		},
		selectAlarmRateInfo(data = {}) {
			let _this = this;
			let params = {};
			if (data) {
				params = {
					"enCode": "TiDB-shengshiqu-shebeiguzhanglv",
					"@province": data.province || data.city || data.district
				}
			} else {
				params = {
					"enCode": "TiDB-quanguo-shebeiguzhanglv" //TiDB-全国-设备故障率
				}
			}
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (!res) return;
					res = res[0];
					_this.alarmRateInfo = res;
					console.log(res, '故障');

					// this.options.series[0].data
					// alarmRate设备故障率、alarmRateAdd对比上月、stopStationLong停战时长、stopStationLongAdd对比上月、stopStationLong设备停战故障率、stopStationRateAdd对比上月
				})
				.catch((err) => {
					console.log(err)
				})
		},
	},
};
</script>
<style lang="scss" scoped>
	.equipmentFailure {
		display: flex;
		width: 100%;

		> div:last-child {
			margin-right: 0;
		}
		.realTimeAlarm {
			flex: 1;
			height: 100%;
			background-color: #1a3342;
			display: flex;
			align-items: center;
			margin-right: 5px;
			box-sizing: border-box;
			> div {
				margin: 0 10px;
			}
		}
	}
</style>
